import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import { omit } from 'lodash';
import $ from 'jquery';
import deepEqual from 'deep-equal';
import displayName from 'component-lib/displayName';

import TableView, { availableContextTypes } from './TableView';
import styles from './CellBase.scss';

const {
    cellPositions: { HEADER, BODY },
} = TableView;

const onCellClick = () => {};

export default class CellBase extends Component {
    static displayName = displayName('TableView/Cellbase');

    static propTypes = {
        cellId: PropTypes.string.isRequired,
        cellType: PropTypes.string.isRequired,
        color: PropTypes.string,
        isFloatingCell: PropTypes.bool,
        styles: PropTypes.any,
        additionalClasses: PropTypes.string,
    };

    static contextTypes = availableContextTypes;

    static defaultProps = {
        isFloatingCell: false,
        additionalClasses: '',
        sortableCell: true,
        color: 'black',
        styles: {},
    };

    componentDidMount() {
        this.setCellWidth();
    }

    shouldComponentUpdate(nextProps) {
        const nextHandlers = omit(nextProps, 'onClick');
        const thisHandlers = omit(this.props, 'onClick');

        return !deepEqual(nextHandlers, thisHandlers);
    }

    setCellWidth() {
        const { cellId } = this.props;
        const { position, firstColumnId } = this.context;
        /* eslint-disable react/no-find-dom-node */
        const alreadySetMinWidth = parseInt($(findDOMNode(this)).css('min-width'), 10);
        const isFirstColumn = firstColumnId === cellId;

        if (position === BODY && alreadySetMinWidth > 0 && isFirstColumn) {
            const newCellWidth = alreadySetMinWidth - 5;
            const newStyles = {
                width: '1%',
                minWidth: newCellWidth,
            };

            const alreadySetMaxWidth = parseInt($(findDOMNode(this)).css('max-width'), 10);
            if (alreadySetMaxWidth) newStyles.maxWidth = alreadySetMaxWidth - 5;

            const alreadySetPadding = parseInt($(findDOMNode(this)).css('padding-left'), 10);
            const newPadding = Math.min(0, alreadySetPadding - 5);
            newStyles.paddingLeft = newPadding;

            $(findDOMNode(this)).css(newStyles);
        }
    /* eslint-enable react/no-find-dom-node */
    }

    /* eslint-disable class-methods-use-this */
    renderCell() {
        throw new Error('CellBase.renderCell method needs to be extended');
    }
    /* eslint-enable class-methods-use-this */

    render() {
        const { cellId, cellType, isFloatingCell } = this.props;
        const { position, firstColumnId } = this.context;
        const additionalProps = omit(this.props, [
            'cellId',
            'cellWidth',
            'position',
            'styleName',
            'styles',
            'onClick',
            'isFloatingCell',
            'cellType',
            'text',
            'sortKey',
            'additionalClasses',
            'isChecked',
            'forceHover',
            'isDisabled',
            'isPartiallyChecked',
            'userName',
            'attachmentCount',
            'highlightKeywords',
            'isHeld',
            'isNeedsReview',
            'isReviewed',
            'onClickCheckbox',
            'isCheckboxEnabled',
            'advancedView',
            'indeterminate',
            'sortableCell',
        ]);

        let additionalClasses = this.props.additionalClasses;

        if (firstColumnId === cellId) {
            additionalClasses += ' first-cell-in-with-active-column';
        }

        if (isFloatingCell) additionalClasses += ' floating-cell';

        additionalClasses += ` ${styles[`${cellType}-cell`]}`;

        const cellProps = {
            ...additionalProps,
            key: cellId,
            onClick: this.onCellClick || onCellClick,
            className: `${position}-cell ${additionalClasses}`,
            'data-position': position,
            'data-cell-type': cellType,
            'data-cell-key': cellId,
        };

        switch (position) {
        case HEADER:
            return (<th {...cellProps}>
                {this.renderCell()}
            </th>);
        case BODY:
        default:
            return (<td {...cellProps}>
                {this.renderCell()}
            </td>);
        }
    }
}
